import { render } from "./DepartmentManagement.vue?vue&type=template&id=7e15fc32&scoped=true"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"

import "@/assets/css/hr-page-shared.css?vue&type=style&index=0&lang=css&external"
import "./DepartmentManagement.vue?vue&type=style&index=1&id=7e15fc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e15fc32"]])

export default __exports__